// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","431":"2af82645","451":"45a4e8dd","523":"1ffe7e97","524":"62341610","933":"669cd14c"}[chunkId] + ".chunk.js";
};